// this component aggregates the serial number info if the quantity
// is > 1
import { useState } from "react";
import { useDispatch } from "react-redux";

import ListIcon from "@mui/icons-material/List";
import { InputAdornment } from "@mui/material";

import { Decimal } from "classes/DecimalClasses";
import { Loading } from "classes/Loading";

import { LineItemTextField } from "components/formFields/LineItemTextField";
import { SerialsEnter } from "components/formFields/Serials/SerialsEnter";
import { SerialsSelect } from "components/formFields/Serials/SerialsSelect";

import { i18n } from "services/i18nService";
import { arrayOfReferencesTypeEditStrFunction } from "services/utility/list";

import { openAlert } from "globalState/alertSlice";

// This is to avoid creating and hydrating the text field with a
// very long string that will never be seen.
const MAX_SERIALS_IN_TEXT_FIELD = 25;

const SERIAL_METADATA = { editStr: arrayOfReferencesTypeEditStrFunction };

export function SerialsAggregator(props) {
  const {
    isSelectVariation,
    value,
    serials,
    quantity,
    binSelectionNeeded,
    onValueChange,
    error,
    locationSelected,
    isReturn,
    enableForNegativeQuantity,
  } = props;

  const dispatch = useDispatch();
  const [selectorOpen, setSelectorOpen] = useState(false);

  const invalidItemQuantity = enableForNegativeQuantity
    ? quantity.eq(Decimal.ZERO)
    : quantity.lte(Decimal.ZERO);

  const isDisabled =
    quantity instanceof Loading || invalidItemQuantity || binSelectionNeeded;

  function formatValue(value) {
    if (!value) {
      return "";
    }
    return value
      .slice(0, MAX_SERIALS_IN_TEXT_FIELD)
      .map(({ name }) => name)
      .filter((serial) => serial)
      .join(", ");
  }

  function onClick() {
    if (isSelectVariation && !locationSelected && !isReturn) {
      const message = i18n("serials.MustSelectLocation");
      dispatch(openAlert({ type: "info", message }));
      return;
    }

    if (!isDisabled) {
      setSelectorOpen(true);
    }
  }

  if (isSelectVariation && !serials) {
    return null;
  }

  return (
    <>
      <LineItemTextField
        value={formatValue(value)}
        onClick={onClick}
        onValueChange={function () {}}
        cursorPointer={!isDisabled}
        error={error}
        endAdornment={
          <InputAdornment position="end">
            <ListIcon />
          </InputAdornment>
        }
        metadata={SERIAL_METADATA}
        disabled={isDisabled}
        dataTesting="serial"
        readOnly
      />
      {isSelectVariation ? (
        <SerialsSelect
          key={selectorOpen}
          open={selectorOpen}
          value={value}
          onValueChange={onValueChange}
          quantity={enableForNegativeQuantity ? quantity.abs() : quantity}
          onClose={() => setSelectorOpen(false)}
          serials={serials}
        />
      ) : (
        <SerialsEnter
          key={selectorOpen}
          open={selectorOpen}
          value={value}
          onValueChange={onValueChange}
          quantity={quantity}
          onClose={() => setSelectorOpen(false)}
        />
      )}
    </>
  );
}
